import FeatureToggleSelector from "features/featureToggles/FeatureToggleSelector";
import { useRoutes } from "react-router-dom";
import routeConfig from "routes/routeConfig";
import { useLocale } from "features/i18n/useLocale";
import "./App.less";
import { registerSparkComponents } from "genesys-spark";
import { useAppSelector } from "./hooks";
import { selectFeatureToggle } from "features/featureToggles/featureToggleSlice";
import FeatureToggle from "enums/FeatureToggle";
import { useEffect, useState } from "react";
import { LoadingSpinner } from "react/components/LoadingSpinner";
import { GlobalAnnouncementRegion } from "react/components/GlobalAnnouncementRegion";

export const App = () => {
    const routes = useRoutes(routeConfig);
    const locale = useLocale();

    // Spark theme management state
    const [sparkLoading, setSparkLoading] = useState(true);
    const isFlareThemeEnabled = useAppSelector((state) => {
        return selectFeatureToggle(state, FeatureToggle.SPARK_FLARE);
    });

    useEffect(() => {
        const initSpark = async () => {
            const theme = isFlareThemeEnabled ? "flare" : "legacy";

            try {
                setSparkLoading(true);
                await registerSparkComponents({
                    theme: theme,
                });
            } catch (err) {
                console.error("Spark Theme loading failed:", err);
            } finally {
                setSparkLoading(false);
            }
        };

        initSpark();
    }, [isFlareThemeEnabled]);

    return (
        <div className="quality-forms-app" lang={locale}>
            <GlobalAnnouncementRegion />
            {sparkLoading ? (
                <LoadingSpinner />
            ) : (
                <>
                    {routes}
                    <FeatureToggleSelector></FeatureToggleSelector>
                </>
            )}
        </div>
    );
};
